import edImage from "../images/team/ed.jpg";
import mdImage from "../images/team/md.jpg";
import joelImage from "../images/team/joel.jpeg";
import petersonImage from "../images/team/peterson.jpeg";

export const teamMembers = [
  {
    name: "Ifeanyi Ezeokoli",
    role: "Managing Director",
    image: mdImage,
    description:
      "Provides strategic leadership and direction for Flexus Solutions. He oversees company growth and ensures the organization consistently delivers premium agricultural products",
  },
  {
    name: "Tayo Banjo",
    role: "Executive Director",
    image: edImage,
    description:
      "Supports the overall leadership of the company by managing core business operations and implementing strategic initiatives.",
  },
  {
    name: "Peterson Paul",
    role: "Export Manager",
    image: petersonImage,
    description:
      "Manages the entire export process, ensuring that all shipments meet international regulations and quality standards and reach global markets safely and on time.",
  },
  {
    name: "Joel Iheanacho",
    role: "Logistics Manager",
    image: joelImage,
    description:
      "Oversees the transportation and supply chain operations at Flexus Solutions. He ensures efficient movement of agricultural produce from farms to processing points and export terminals.",
  },
];
